import { Container, Stack, Typography, Button } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import bgSuccess from '../../../assets/order-confirmed-fatty.png';
// environment import removed (unused)
import leaves from '../../../assets/leaves.png';
const OrderSuccess = () => {
  const navigate = useNavigate();
  return (
    <Container
      maxWidth="xl"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        py: { xs: 4, md: 8 },
        backgroundColor: 'white',
        position: 'relative',
      }}
    >
      <img
        src={leaves}
        alt="leaves"
        style={{
          position: 'absolute',
          top: 8,
          left: 8,
          width: 118,
          height: 'auto',
          maxWidth: '20%',
        }}
      />

      <Stack
        sx={{
          backgroundColor: '#fff',
          padding: { xs: 3, md: 4 },
          borderRadius: '10px',
          width: { xs: '95%', sm: '85%', md: '70%' },
          height: 'auto',
          boxShadow: '0px 0px 50px 0px #4545450D',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: { xs: 3, md: 4 },
        }}
      >
        <img
          src={bgSuccess}
          alt="your order is confirmed"
          style={{
            width: '100%',
            maxWidth: 500,
            height: 'auto',
            objectFit: 'cover',
            borderRadius: 8,
          }}
        />

        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '24px', sm: '32px', md: '40px' },
            fontFamily: 'Jost , sans-serif',
            fontWeight: '700',
            color: '#172B4D',
            textAlign: 'center',
          }}
        >
          Your order is successfully placed
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '14px', md: '16px' },
            maxWidth: { xs: '100%', md: '40%' },
            textAlign: 'center',
            fontWeight: '400',
            color: '#828282',
            lineHeight: '1.6',
            fontFamily: 'Jost , sans-serif',
          }}
        >
          Thank you for your order! We are currently processing it and will
          notify you once it's ready. If you have any questions or need
          assistance, please don't hesitate to contact us.
        </Typography>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems="center"
          gap={2}
          sx={{ width: '100%', justifyContent: 'center' }}
        >
          <Button
            onClick={() => navigate('/menu', { state: { openBranchDialog: true } })}
            variant="contained"
            color="primary"
            sx={{
              backgroundColor: '#F3F3F3',
              color: '#172B4D',
              fontSize: { xs: '14px', md: '14px' },
              fontWeight: '600',
              padding: { xs: '12px 24px', md: '14px 32px' },
              borderRadius: '43px',
              boxShadow: 'none',
              textTransform: 'capitalize',
              fontFamily: 'Jost , sans-serif',
              width: { xs: '100%', sm: 'auto' },
              '&:hover': {
                backgroundColor: '#F3F3F3',
                color: '#172B4D',
                boxShadow: 'none',
              },
            }}
          >
            Back to Menu
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
};

export default OrderSuccess;
